import actions from './actions'
import mutations from './mutations'
import state from './state'
import getters from './getters'

const component = {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
}

export default component
